import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzIconModule } from "ng-zorro-antd/icon";
import { Observable } from "rxjs";
import { TenantContextService } from "src/app/services/tenant-context.service";

/**
 * Bandeau global affiché quand un super-admin a démarré une impersonation.
 *
 * - Visible UNIQUEMENT pendant l'impersonation (sinon DOM vide).
 * - Affiche le label cible + un bouton "Quitter" qui appelle stopImpersonation
 *   puis redirige vers la liste des institutions (point de départ naturel
 *   pour reprendre le travail global).
 * - Inséré dans le `dashboard-layout` au-dessus du `router-outlet`.
 */
@Component({
  selector: "app-impersonation-banner",
  standalone: true,
  imports: [CommonModule, NzIconModule, NzButtonModule],
  templateUrl: "./impersonation-banner.component.html",
  styleUrl: "./impersonation-banner.component.less",
})
export class ImpersonationBannerComponent {
  readonly tenantId$: Observable<string | null>;
  readonly tenantLabel$: Observable<string | null>;

  constructor(
    private tenantContext: TenantContextService,
    private router: Router
  ) {
    this.tenantId$ = this.tenantContext.impersonatingTenantId$;
    this.tenantLabel$ = this.tenantContext.impersonatingTenantLabel$;
  }

  exit(): void {
    // Le bandeau redirige explicitement vers la liste des institutions juste
    // après → pas besoin de reloader la route courante (qui n'existera plus).
    this.tenantContext.stopImpersonation(false);
    this.router.navigate(["/administration/referential/institutions/list"]);
  }
}
